"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitTemplateA = void 0;
require('slick-carousel');
function InitTemplateA() {
    const toggleProductInfo = () => {
        jQuery('#toggle-product-info').click(function () {
            jQuery('#product-info').toggleClass('closed');
            jQuery('#toggle-product-info').toggleClass('open');
        });
    };
    const onFormSubmitClick = () => {
        jQuery('.FormSubmitButton').click(function () {
            setTimeout(() => {
                if (jQuery('.Form__Element.ValidationFail').length === 0) {
                    jQuery('body').addClass('form-submitted');
                    if (jQuery('#form-submitted-anchor').length) {
                        const formSubmittedAnchorTop = jQuery('#form-submitted-anchor').position().top;
                        jQuery(window).scrollTop(formSubmittedAnchorTop - 28);
                    }
                }
            }, 500);
        });
    };
    window.heroSliderShowNext = () => {
        jQuery('.o-hero-container .o-slider-content-frontpage .o-button').click(function (e) {
            const parent = jQuery('.o-hero-container');
            const slideAmount = jQuery('.o-hero-container .slick-slide').length;
            const currentSlideIdx = eval(jQuery('.o-hero-container .slick-slide.slick-current').data('slick-index'));
            const nextSlideIdx = (currentSlideIdx === slideAmount) ? 0 : currentSlideIdx + 1;
            window.setSlide(nextSlideIdx, parent);
            e.preventDefault();
        });
    };
    window.scrollHelper = (triggerElem, targetElem) => {
        jQuery(triggerElem).click(function (e) {
            e.preventDefault();
            const topPos = jQuery(targetElem).position().top;
            jQuery("html, body").animate({
                scrollTop: topPos
            });
        });
    };
    const setDocumentVisible = () => {
        jQuery('.o-hero-container, .o-container, .site-navigation, .row, .hero-image').css("visibility", "visible");
        // Loader elements
        if (jQuery('.loader-img').length && jQuery('.loader-layer').length) {
            jQuery('.loader-img, .loader-layer').fadeOut("fast");
        }
    };
    jQuery(document).ready(function () {
        toggleProductInfo();
        onFormSubmitClick();
        //heroSliderShowNext();
        setDocumentVisible();
    });
}
exports.InitTemplateA = InitTemplateA;
